import React, { FC } from 'react';

import { BaseAutocompleteOption } from '@savgroup-front-common/types';

import { safeFormattedIntlString } from '../../../../formatters';
import { StringHelper } from '../../../../helpers/stringHelpers';
import {
  $BoldOptionName,
  $HighlightedMatch,
  $OptionDescription,
} from '../Autocomplete.styles';

const DescriptionOptionFormatter: FC<
  BaseAutocompleteOption & { search?: string }
> = ({ description, label, search }) => {
  if (!search) {
    return (
      <>
        <$BoldOptionName>{safeFormattedIntlString(label)}</$BoldOptionName>
        {description && (
          <$OptionDescription>
            {safeFormattedIntlString(description)}
          </$OptionDescription>
        )}
      </>
    );
  }

  const labelString = safeFormattedIntlString(label);
  const descriptionString = safeFormattedIntlString(description);

  const labelSegments = StringHelper.highlightSearchMatches({
    target: labelString,
    searchString: search,
  });

  const descriptionSegments = descriptionString
    ? StringHelper.highlightSearchMatches({
        target: descriptionString,
        searchString: search,
      })
    : [];

  return (
    <>
      <$BoldOptionName>
        {labelSegments.map((segment, index) => {
          if (segment.isMatch) {
            return (
              <$HighlightedMatch key={index}>{segment.text}</$HighlightedMatch>
            );
          }

          return <React.Fragment key={index}>{segment.text}</React.Fragment>;
        })}
      </$BoldOptionName>

      {description && (
        <$OptionDescription>
          {descriptionSegments.map((segment, index) => {
            if (segment.isMatch) {
              return (
                <$HighlightedMatch key={index}>
                  {segment.text}
                </$HighlightedMatch>
              );
            }

            return <React.Fragment key={index}>{segment.text}</React.Fragment>;
          })}
        </$OptionDescription>
      )}
    </>
  );
};

export default DescriptionOptionFormatter;
